export function secondsToTimestamp(seconds) {
  let min, sec;

  seconds = Math.round(seconds);

  min = Math.floor(seconds / 60);
  sec = seconds % 60;

  if (min < 10) min = `0${min}`;
  if (sec < 10) sec = `0${sec}`;

  return `${min}:${sec}`;
}



// WEBPACK FOOTER //
// ./src/tools/conversion/time.js